/**
 * SA AI Possibilities - Web Component
 * ESM 模块入口
 * 接口隔离：只暴露必要的公共 API
 */

import { SaAiPossibilitiesController } from './sa-ai-possibilities-controller.js';

class SaAiPossibilities extends HTMLElement {
  constructor() {
    super();
    this.controller = null;
  }

  connectedCallback() {
    this.initController();
  }

  disconnectedCallback() {
    this.destroy();
  }

  async initController() {
    this.controller = new SaAiPossibilitiesController({
      element: this,
      onIndexChange: (index, prevIndex) => {
        this.dispatchEvent(new CustomEvent('indexchange', {
          detail: { index, prevIndex },
          bubbles: true
        }));
      }
    });
    
    try {
      await this.controller.init();
      this.dispatchEvent(new CustomEvent('ready', { bubbles: true }));
    } catch (error) {
      console.error('SaAiPossibilities init error:', error);
    }
  }

  // 公共 API
  getCurrentIndex() {
    return this.controller?.getCurrentIndex() ?? 0;
  }

  getTotalBlocks() {
    return this.controller?.getTotalBlocks() ?? 0;
  }

  destroy() {
    if (this.controller) {
      this.controller.destroy();
      this.controller = null;
    }
  }
}

// 注册自定义元素
if (!customElements.get('sa-ai-possibilities')) {
  customElements.define('sa-ai-possibilities', SaAiPossibilities);
}

export { SaAiPossibilities };

